var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiSmartphoneLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35718 4.3148V20.3404H17.3732V4.3148H7.35718ZM6.35558 2.3116H18.3748C18.6404 2.3116 18.8952 2.41713 19.083 2.60496C19.2709 2.7928 19.3764 3.04756 19.3764 3.3132V21.342C19.3764 21.6077 19.2709 21.8625 19.083 22.0503C18.8952 22.2381 18.6404 22.3437 18.3748 22.3437H6.35558C6.08993 22.3437 5.83517 22.2381 5.64734 22.0503C5.4595 21.8625 5.35397 21.6077 5.35397 21.342V3.3132C5.35397 3.04756 5.4595 2.7928 5.64734 2.60496C5.83517 2.41713 6.08993 2.3116 6.35558 2.3116ZM12.3652 17.3356C12.6308 17.3356 12.8856 17.4412 13.0734 17.629C13.2613 17.8168 13.3668 18.0716 13.3668 18.3372C13.3668 18.6029 13.2613 18.8576 13.0734 19.0455C12.8856 19.2333 12.6308 19.3388 12.3652 19.3388C12.0995 19.3388 11.8448 19.2333 11.657 19.0455C11.4691 18.8576 11.3636 18.6029 11.3636 18.3372C11.3636 18.0716 11.4691 17.8168 11.657 17.629C11.8448 17.4412 12.0995 17.3356 12.3652 17.3356Z",
    fill: "#383E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiSmartphoneLine);
export default __webpack_public_path__ + "static/media/ri_smartphone-line.e2552f2b9f6972ac1ec2152f2bd8be5b.svg";
export { ForwardRef as ReactComponent };